import docImage from '@/assets/icons/file_types/doc.svg';
import pdfImage from '@/assets/icons/file_types/pdf.svg';
import xlsImage from '@/assets/icons/file_types/xls.svg';
import pptImage from '@/assets/icons/file_types/ppt.svg';
import txtImage from '@/assets/icons/file_types/txt.svg';
import pngImage from '@/assets/icons/file_types/png.svg';
import jpgImage from '@/assets/icons/file_types/jpg.svg';
import gifImage from '@/assets/icons/file_types/gif.svg';
import svgImage from '@/assets/icons/file_types/svg.svg';
import zipImage from '@/assets/icons/file_types/zip.svg';
import unknownImage from '@/assets/icons/file_types/unknown.svg';

export default {
  computed: {
    showPreview() {
      return this.$store.getters.showPreview;
    },
    selectedAttachment() {
      return this.$store.getters.selectedAttachment;
    },
    currentAttachments() {
      return this.$store.getters.currentAttachments;
    },
  },
  methods: {
    toggleShowAttachmentPreview(toggleValue, attachment, attachmentsArray) {
      this.$store.dispatch('toggleShowPreview', toggleValue);
      this.$store.dispatch('updateSelectedAttachment', attachment);
      this.$store.dispatch('updateAttachmentsArray', attachmentsArray);
    },
    getIconUrl(fileName) {
      if (fileName) {
        const parts = fileName.split('.');
        const type = (parts[parts.length - 1] || 'txt').toLowerCase();

        switch (type) {
          case 'docx':
          case 'doc':
            return docImage;
          case 'pdf':
            return pdfImage;
          case 'xlsx':
          case 'xls':
            return xlsImage;
          case 'pptx':
          case 'ppt':
            return pptImage;
          case 'txt':
            return txtImage;
          case 'jpg':
          case 'jpeg':
            return jpgImage;
          case 'png':
            return pngImage;
          case 'gif':
            return gifImage;
          case 'svg':
            return svgImage;
          case 'zip':
            return zipImage;
          default:
            return unknownImage;
        }
      } else {
        return unknownImage;
      }
    },
  },
};
